export default "__VITE_ASSET__BVPtXz90__"